import { Component, OnInit } from '@angular/core';
import { PatientView } from 'src/app/model/patient';
import { PatientSearch } from 'src/app/model/patient/patient-search';
import { PatientService } from 'src/app/services/patient.service';
import { IntegratedAdmissionWizardService } from '../../integrated-admission/service/integrated-admission-wizard.service';
import { BudgetWizardService } from '../services/budget.wizard.service';

@Component({
  selector: 'app-budget-patient',
  templateUrl: './budget-patient.component.html',
  styleUrls: ['./budget-patient.component.css']
})
export class BudgetPatientComponent implements OnInit {

  patient: PatientSearch;
  patientView: PatientView;
  loading: boolean;

  constructor( private service: BudgetWizardService,
    private patientService: PatientService ) {}

  async ngOnInit() {
     this.loading = true;
      if (this.service.PatientId) {
        this.patientView = await this.patientService
            .getPatientView(this.service.PatientId);
      }
      this.loading = false;
  }

  cancel() {
    history.back();
  }

  onPatientSelected(patientSearch: PatientSearch) {
    this.patient = patientSearch;
    this.service.setPatient(patientSearch.Id);
  }

}
